import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@medme/ui"
import { ChevronsUpDown, GalleryVerticalEnd } from "lucide-react"
import { useTranslation } from "react-i18next"
import type { ClinicInfo } from "../model/types"

// Hardcoded placeholder data
const clinicInfo: ClinicInfo = {
	name: "Название сети",
	icon: GalleryVerticalEnd,
}

export function SidebarHeader() {
	const { t } = useTranslation()
	return (
		<div className="flex items-center justify-between pt-2 px-1">
			<div className="flex items-center gap-2">
				{clinicInfo.icon && (
					<clinicInfo.icon className="size-6" aria-hidden="true" />
				)}
				<span className="font-semibold">{clinicInfo.name}</span>
			</div>
			<DropdownMenu>
				<DropdownMenuTrigger asChild>
					<button
						type="button"
						className="p-1 rounded-md hover:bg-accent"
						aria-label="Switch clinic"
					>
						<ChevronsUpDown className="size-4" aria-hidden="true" />
					</button>
				</DropdownMenuTrigger>
				<DropdownMenuContent align="end">
					<DropdownMenuItem disabled>
						{t("sidebar.header.no-actions-available")}
					</DropdownMenuItem>
				</DropdownMenuContent>
			</DropdownMenu>
		</div>
	)
}
